export const CreditUsageCategoryEnum = {
    SPORT: {
        code: "SPORT",
        label: "ورزش",
        active: true,
        disabled: false,
        description: "قابل استفاده در استخرها، سالن‌ها و مجموعه‌های ورزشی جیم‌پین",
    },
    PSYCHOLOGY: {
        code: "PSYCHOLOGY",
        label: "روانشناسی",
        active: false,
        disabled: true,
        badge: "به‌زودی — در حال حاضر غیرفعال",
        description: "خدمات مشاوره و سلامت روان (به‌زودی)",
    },
    SPORTS_GEAR: {
        code: "SPORTS_GEAR",
        label: "خرید",
        active: false,
        disabled: true,
        badge: "به‌زودی — در حال حاضر غیرفعال",
        description: "تجهیزات، مکمل‌ها و پوشاک ورزشی (به‌زودی)",
    },
    CINEMA: {
        code: "CINEMA",
        label: "فرهنگ",
        active: false,
        disabled: true,
        badge: "به‌زودی — در حال حاضر غیرفعال",
        description: "سینما، تئاتر، موزه و گالری",
    },
};

export const CreditUsageCategoryList = Object.values(CreditUsageCategoryEnum);
